// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"ModalQuestions_containerPrincipal__BZ9d9","labelParagraph":"ModalQuestions_labelParagraph__1J0gq","labelQuestion":"ModalQuestions_labelQuestion__8jy7E"};